export default "__VITE_ASSET__32a069df__"